import PropTypes from "prop-types";
import React from "react";

import { DefaultDataCell, LinkDataCell } from "../../Layout/DataGrid";
import { formatDate } from "../../../helpers/dateHelpers";
import { formatDimension, formatQuantityValue } from "../../../helpers/unitOfMeasurementHelpers";
import MillStatusCell from "./MillStatusCell";

const formatQuantityRolls = (quantity, rolls) => {
  const formattedQuantity = formatQuantityValue(quantity, undefined, "");
  const formattedRolls = formatQuantityValue(rolls, undefined, "");
  return formattedQuantity || formattedRolls ? `${formattedQuantity} / ${formattedRolls}` : "";
};

const formatRevisedDate = (ship, drop, days, date) => (ship && drop ? `${formatDate(ship, date)} / ${formatDate(drop, date)} (${days})` : "");

const ColumnComponent = ({ item, routerParams, userMetadata }) => {
  const { customerId, customerPOId, loadId } = routerParams;
  const { revisedShipDate, revisedDeliveryDate, deliveryDays = "" } = item;
  return (
    <div className="data-grid__column">
      <DefaultDataCell emptyValue="" className="--last --mill-order" value={item.millOrderId} />
      <DefaultDataCell emptyValue="" className="--first" value={item.customerPOId} />
      <DefaultDataCell emptyValue="" value={item.customerId} />
      <DefaultDataCell emptyValue="" value={formatRevisedDate(revisedShipDate, revisedDeliveryDate, deliveryDays, userMetadata.dateDisplayFormat)} />
      <DefaultDataCell emptyValue="" value={item.orderedProduct.productName} />
      <DefaultDataCell emptyValue="" className="--last" value={formatDimension(item.orderedProduct.dimension)} />
      <MillStatusCell className="--first" millOrderStatus={item.millOrderStatus} />
      <DefaultDataCell emptyValue="" value={formatQuantityRolls(item.quantityConfirmed, item.rollsConfirmed)} />
      <DefaultDataCell emptyValue="" value={formatQuantityRolls(item.quantityPlanning, item.rollsPlanning)} />
      <DefaultDataCell emptyValue="" value={formatQuantityRolls(item.quantityProduced, item.rollsProduced)} />
      <DefaultDataCell emptyValue="" value={formatQuantityRolls(item.quantityLoaded, item.rollsLoaded)} />
      <DefaultDataCell emptyValue="" value={formatQuantityRolls(item.quantityShipped, item.rollsShipped)} />
      <DefaultDataCell emptyValue="" className="--last" value={item.millStatus} />
      <DefaultDataCell emptyValue="" className="--first" value={item.carrier} />
      <LinkDataCell value={item.shipmentId} to="BillOfLadingList" params={{ customerId, customerPOId, loadId, shipmentId: item.id }} />
      <DefaultDataCell emptyValue="" value={item.vehicleId} />
      <DefaultDataCell emptyValue="" value={formatDate(item.loadedDate, userMetadata.dateDisplayFormat, "")} />
      <DefaultDataCell emptyValue="" value={formatDate(item.shippedDate, userMetadata.dateDisplayFormat, "")} />
    </div>
  );
};

ColumnComponent.propTypes = {
  item: PropTypes.object,
  routerParams: PropTypes.object,
  userMetadata: PropTypes.object
};

ColumnComponent.defaultProps = {
  item: {},
  routerParams: {},
  userMetadata: {}
};

export default ColumnComponent;



// WEBPACK FOOTER //
// ./src/components/MillOrder/DataGrid/ColumnComponent.js